// VocabRegister.js (Finalized)

export const VocabRegister = {
    'register_title' : ['Únete a MedCleir', 'Join MedCleir'],
    'already_have_account' : ['¿Tienes ya una cuenta?', 'Already have an account?'],
    'login' : ['Inicia sesion', 'Login'],
    'back_home' : ['Inicio', 'Back home'],

    'professional_toggle_title': ['Cuenta profesional', 'Professional account'],
    'professional_toggle_desc': ['Quiero unirme a MedCleir como profesional.', 'I want to join MedCleir as a professional.'],

    'greetings' : ['Comencemos creando tu cuenta.',"Let's start by creating your account."],
    'pre_submit_instructions' : ['Ayudanos completando la siguiente informacion:', 'Help us filling out the following fields:'],
    
    //  ----------------- INTRO STEP -----------------
    'intro_title': ['Antes de comenzar', 'Before you start'],
    'intro_message': ['Ten en mano esta información tuya:', 'Have in mind this data of yours:'],

    //  ----------------- NAVIGATION -----------------
    'next_label': ['Siguiente', 'Next'],
    'prev_label': ['Anterior', 'Previous'],
    'register_label': ['Registrarme', 'Register'],

    //  ----------------- STEP TITLES (Simplified and Corrected) -----------------
    'title_personal_info': ['Personal', "Personal Info"], 
    'title_address': ['Dirección', "Address"], 
    'title_immutables': ['Biográfico', "Biographical Data"], 
    'title_general_info': ['General', "General Info"], 

    //  ----------------- FIELDS -----------------
    'email' : ['Correo electrónico', 'Email'],
    'password' : ['Contraseña', 'Password'],
    'username' : ['Nombre de Usuario', 'Username'],
    'name' : ['Nombre', 'Name'],
    'lastname_1' : ['Apellido Paterno', 'Last Name 1'],
    'lastname_2' : ['Apellido Materno', 'Last Name 2'],
    
    'street' : ['Calle', 'Street'],
    'number' : ['Número Exterior', 'Exterior Number'],
    'interior_number' : ['Número Interior', 'Interior Number'],
    'city' : ['Ciudad', 'City'],
    'state' : ['Estado', 'State'],
    'zip_code' : ['Código Postal', 'Zip Code'],
    'country' : ['País', 'Country'], 
    
    'bloodtype' : ['Tipo de Sangre', 'Blood Type'],
    'birthday' : ['Fecha de Nacimiento', 'Birth Date'],
    'sex_at_birth' : ['Sexo al nacer', 'Sex at birth'],
    'female' : ['Mujer', 'Female'],
    'male' : ['Hombre', 'Male'],
    'birthplace' : ['Lugar de nacimiento', 'Birth Place'],
    'sex' : ['Sexo', 'Sex'], 

    'height' : ['Altura', 'Height'],
    'weight' : ['Peso', 'Weight'],
    'marital_status' : ['Estado Civil', 'Marital Status'],
    'occupation' : ['Ocupación', 'Occupation'],
    'religion' : ['Religión', 'Religion'],
    'education' : ['Escolaridad', 'Education'],
    
    //  ----------------- HELP & SUBMIT -----------------
    'why_label' : ['¿Por qué necesitamos esta información?', 'Why do we need this information?'], 
    'why_explanation' : ['MedCleir es primordialmente una herramienta para la creación y manejo del expediente clínico, nuestro propósito principal es documentar el proceso de atención médica de manera completa y organizada, para ello incluimos tu información personal relevante, diagnósticos, tratamientos y resultados, facilitando una atención integral y personalizada. ¿Tienes más dudas de cómo tratamos tu información? visita:', 'MedCleir is a tool for creating and managing your clinical record. Our purpose is to document your medical care completely and efficiently, including personal data, diagnoses, treatments, and results, to facilitate comprehensive and personalized care. If you have more questions about how we handle your data, please visit:'], 
    
    'submit_button' : ['Registrame', 'Register'],
    'submit_tooltip' : ['Nos encantará tenerte a bordo :)', "We'd love to have you on board :)"],
    
    //  ----------------- POST SUBMIT -----------------
    'post_submit_title' : ['¡Ya casi!', 'Almost There!'], 
    'post_submit_message' : ['Te enviaremos un correo de confirmación, por favor revisa tu bandeja (y el folder de spam por si acaso)', "Great! We'll send you a confirmation email. Please check your inbox (and spam folder, just in case)."], 
}